import { Arrow } from "@radix-ui/react-dropdown-menu";
import { breakpoints } from "pages/flyer/builder/drawer/components/breakpoints";
import { styled } from "pages/flyer/builder/drawer/styles/stitches.config";

export const DMArrow = styled(Arrow, { fill: "$panel", bp: breakpoints });
